import { useState, useEffect } from "react";
import {
	IonApp,
	IonRouterOutlet,
	IonSplitPane,
	setupIonicReact
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Menu from "./components/Menu";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./App.css";

import Properties from "./pages/property/Properties";
import Tenants from "./pages/tenant/Tenants";
import NewProperty from "./pages/property/New";
import NewTenant from "./pages/tenant/New";
import TenantDetails from "./pages/tenant/Details";
import Expanses from "./pages/Expanses";
import Rents from "./pages/Rents";
import PropertyDetails from "./pages/property/Details";
import Home from "./pages/Home";
import UpdateTenant from "./pages/tenant/Update";
import UpdateProperty from "./pages/property/Update";
import Loading from "./components/Loading";
import StartRenting from "./pages/property/StartRenting";
import useStore from "./store/store";
import Users from "./pages/user/List";
import NewUser from "./pages/user/New";
import Profile from "./pages/user/Profile";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AnimatedSwitch from "./pages/AnimatedSwitch";

setupIonicReact();

const App: React.FC = () => {
	const { isLoggedIn, isLoading } = useStore(state => state);

	return (
		<IonApp>
			{isLoading === "true" && <Loading />}
			{isLoggedIn === "true" ? (
				<IonReactRouter>
					<IonSplitPane contentId="main">
						<Menu />
						<IonRouterOutlet id="main" animated={true}>
							<AnimatedSwitch>
								<Route path="/" exact={true}>
									<Home />
								</Route>
								<Route path="/properties" exact={true}>
									<Properties />
								</Route>
								<Route path="/properties/new" exact={true}>
									<NewProperty />
								</Route>
								<Route
									path="/properties/u/:propertyId"
									exact={true}
									component={(props: any) => (
										<UpdateProperty {...props} />
									)}
								></Route>
								<Route
									path="/property/:propertyId"
									exact={true}
									component={(props: any) => (
										<PropertyDetails {...props} />
									)}
								></Route>
								<Route
									path="/renting/:propertyId"
									exact={true}
									component={(props: any) => (
										<StartRenting {...props} />
									)}
								></Route>
								<Route path="/tenants" exact={true}>
									<Tenants />
								</Route>
								<Route
									path="/tenant/:tenantId"
									exact={true}
									component={(props: any) => (
										<TenantDetails {...props} />
									)}
								></Route>
								<Route path="/tenants/new" exact={true}>
									<NewTenant />
								</Route>
								<Route
									path="/tenant/u/:tenantId"
									exact={true}
									component={(props: any) => (
										<UpdateTenant {...props} />
									)}
								></Route>
								<Route path="/expanses" exact={true}>
									<Expanses />
								</Route>
								<Route path="/rents" exact={true}>
									<Rents />
								</Route>
								<Route path="/users" exact={true}>
									<Users />
								</Route>
								<Route path="/profile" exact={true}>
									<Profile />
								</Route>
								<Route path="/users/new" exact={true}>
									<NewUser />
								</Route>
							</AnimatedSwitch>
						</IonRouterOutlet>
					</IonSplitPane>
				</IonReactRouter>
			) : (
				<IonReactRouter>
					<AnimatedSwitch>
						<Route path="/" exact={true}>
							<Login />
						</Route>
						<Route path="/fp" exact={true}>
							<ForgotPassword />
						</Route>
						<Route path="/rp" exact={true}>
							<ResetPassword />
						</Route>
					</AnimatedSwitch>
				</IonReactRouter>
			)}
		</IonApp>
	);
};

export default App;
